/**
 * Section office facilities reuse the 3-digit CCMS section code as `legacyId`.
 * Those codes are not useful in most chrome; keep fetching them for search and permissions.
 */
export function isThreeDigitSectionId(value?: string | null): boolean {
  return /^\d{3}$/.test(value?.trim() ?? "");
}

/** Facility IDs shown in headers and tables. 3-digit section codes are omitted. */
export function displayableFacilityLegacyId(value?: string | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed || isThreeDigitSectionId(trimmed)) return null;
  return trimmed;
}
